export default __webpack_public_path__ + "static/media/icon-three-dots.cf6ba07e.svg";